module.exports = __webpack_public_path__ + "static/media/21ECLAC3.35bb51f2.jpg";